module.exports = __webpack_public_path__ + "img/Hongkong-4-hover.0ae95083.jpg";